import React, { useMemo } from 'react';
import { useHovercardStore, HovercardAnchor, Hovercard } from '@ariakit/react';

interface CellWithTooltipProps {
  content: React.ReactNode;
  maxSize?: number;
  minSize?: number;
  enableTooltip?: boolean;
  className?: string;
  condensed?: boolean;
}

export default function CellWithTooltip({
  content,
  maxSize,
  minSize,
  enableTooltip,
  className = '',
  condensed = false,
}: CellWithTooltipProps) {
  const hovercard = useHovercardStore({
    showTimeout: 200,
    hideTimeout: 0,
    placement: 'top'
  });

  if (!enableTooltip) {
    if (condensed) {
      return <span className="line-clamp-2 w-full">{content}</span>;
    }
    return content;
  }

  return (
    <>
      <HovercardAnchor
        store={hovercard}
        className="block"
      >
        <div
          className={`truncate whitespace-nowrap cursor-help ${className}`}
          style={{
            maxWidth: maxSize ? `${maxSize}px` : undefined,
            minWidth: minSize ? `${minSize}px` : undefined,
            width: '100%'
          }}
        >
          {content}
        </div>
      </HovercardAnchor>

      <Hovercard
        store={hovercard}
        gutter={8}
        className="z-[9999] max-w-sm rounded-md border border-gray-200 bg-white p-3 shadow-lg"
      >
        <div className="text-sm text-gray-900 break-words max-h-64 overflow-y-auto">
          {content}
        </div>
      </Hovercard>
    </>
  );
}
